import moment, { Moment } from "moment";

/**
 * Generate a Moment object based on UTC values. YOUR PROVIDED TIME MUST BE UTC!
 * @param minute Optional. (0-59) UTC minute.
 * @param hour UTC hour. (0-23) UTC hour.
 * @param day Optional. (1-31) If not provided, the current day (UTC) is used.
 * @param month Optional. Month (1-12). Will be converted to JS (0-11) INSIDE this function
 */
export const generateUTCDate = (
  minute: number,
  hour: number,
  day?: number,
  month?: number
): Moment => {
  // Time right now - is used for comparison
  const now = moment.utc();
  // The date we will return
  const date = moment.utc();

  // Set all values in UTC
  date.millisecond(0); // Reset
  date.second(0); // Reset
  date.minute(minute);
  date.hour(hour);

  // Check what time specifications have been provided
  if (day && month) {    
    // If month is "less" than today, it is next year
    if (month < now.month()) {
      date.year(now.year() + 1);
    }
    
    // Day and month provided
    date.date(day);
    date.month(month - 1); // Months in Moment are 0-indexed, but we want 1-indexed from the AFTN format
  } else if (day) {
    // First determine month (if the day is 31 and the current month doesn't have 31 days, we get some odd behavior (because the month will roll over) that we can avoid by setting the month first and then the date)
    // If the difference is at least 2 days, it is next month. Example: 31-1 = 30 (which is next month) while 13-14 = 1 (which is same month)
    if (now.date() - day > 2) {
      date.month(now.month() + 1);
    } else if (day - now.date() > 2) {
      // If day is more than 2 days ahead, it is last month. Example: 31-1 = 30 (which is last month) while 1-2 = 1 (which is same month)
      date.month(now.month() - 1);
    }

    // Only day set, no month
    date.date(day);
  } else {
    // No day or month is set, only hour
    // If hour is "less" than now, it is next day
    if (hour < now.hour()) {
      date.date(now.date() + 1);
    }
  }

  return date;
};
